import { SelectHTMLAttributes, forwardRef } from 'react';
import styles from './Input.module.css';

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  options: { value: string; label: string }[];
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ label, options, className = '', id, ...rest }, ref) => {
    const selectId = id || `select-${Math.random().toString(36).slice(2, 9)}`;
    return (
      <div className={styles.formGroup}>
        {label && <label className={styles.label} htmlFor={selectId}>{label}</label>}
        <select
          ref={ref}
          id={selectId}
          className={`${styles.select}${className ? ` ${className}` : ''}`}
          {...rest}
        >
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      </div>
    );
  },
);
